export const updates = {
  latest: [
    "v0.1.1 - 07/07/2026",
    "Added Classroom Mode: untimed practice with no leaderboard submission",
    "Desktop game panel no longer shows the in-game scrollbar",
    "Fixed Bailey J. Williams player image",
  ],
  coming: [
    "Expanded players for Online mode",
    "Daily Challenge mode",
    "Challenges in Profile",
    "New badge types"
  ]
};
